import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { LabelSetting } from '../../../../i18n/locale-helper'

@Component({
  template: require('./template.html'),
})
class MailboxComponent extends Vue {


  /**
   *
   */
  constructor() {
    super();
  }
  get lblSetting() {
    return LabelSetting.Global;
  }
}

export default MailboxComponent;